import { createSlice } from "@reduxjs/toolkit";
import { getCategoryById,getCatgeoryList } from "./ThunkActions";
import { iCategoryState, REDUCER_NAME } from "./Types"; 

// Define initial state based on the provided structure
const initialState: iCategoryState = {
  isLoading: false,
  category: null,
  errorMessage: null,
  categoryList: [],
};
export const categorySlice = createSlice({
  name: REDUCER_NAME, 
  initialState,
  reducers: {
    resetCategoryState: () => {
      return initialState; // Reset to the initial state
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCategoryById.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCategoryById.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.category = payload.data.category; // This should be a single order object
          state.isLoading = false;
        }
      })
      .addCase(getCategoryById.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch order data";
        state.isLoading = false;
      })

      .addCase(getCatgeoryList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCatgeoryList.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          state.categoryList = payload.data?.data; 
          state.isLoading = false;
        }
      })
      .addCase(getCatgeoryList.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch order data";
        state.isLoading = false;
      });
  },
});

export const { resetCategoryState } = categorySlice.actions;
export default categorySlice.reducer;
